const carouselItems = [
  {
    title: '热血日漫巅峰对决',
    desc: '从经典到新番，盘点日漫史上最燃战斗场景与角色成长弧光',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Japanese%20manga%20battle%20scene%20with%20dynamic%20action%20composition%2C%20warm%20orange%20and%20red%20energy%20bursts%2C%20clean%20anime%20illustration%20style%2C%20dramatic%20lighting%2C%20minimal%20cream%20background%2C%20bold%20lines&width=1200&height=600&seq=carousel-manga-01&orientation=landscape',
    tag: '日漫',
    icon: 'ri-fire-line',
  },
  {
    title: '韩漫竖屏阅读革命',
    desc: '探索韩漫条漫格式如何改变全球漫画阅读习惯，沉浸式下拉体验',
    img: 'https://readdy.ai/api/search-image?query=Vertical%20webtoon%20style%20illustration%20with%20beautiful%20Korean%20digital%20art%2C%20flowing%20panel%20composition%2C%20soft%20pastel%20colors%2C%20romantic%20and%20dramatic%20atmosphere%2C%20minimal%20white%20background&width=1200&height=600&seq=carousel-manga-02&orientation=landscape',
    tag: '韩漫',
    icon: 'ri-smartphone-line',
  },
  {
    title: '国漫黄金时代来临',
    desc: '从一人之下到镖人，国漫正以独特的中式美学征服海内外读者',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20fantasy%20scene%20with%20martial%20artists%20in%20flowing%20robes%2C%20elegant%20golden%20and%20russet%20tones%2C%20traditional%20aesthetic%20with%20modern%20composition%2C%20minimal%20warm%20background&width=1200&height=600&seq=carousel-manga-03&orientation=landscape',
    tag: '国漫',
    icon: 'ri-flag-line',
  },
  {
    title: '奇幻异世界冒险指南',
    desc: '从转生到召唤，带你一览当下最火爆的异世界题材漫画精选合集',
    img: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20illustration%20with%20floating%20islands%20and%20mystical%20creatures%2C%20bright%20golden%20and%20emerald%20color%20palette%2C%20clean%20anime%20art%20style%2C%20whimsical%20atmosphere%2C%20minimal%20neutral%20background&width=1200&height=600&seq=carousel-manga-04&orientation=landscape',
    tag: '奇幻',
    icon: 'ri-magic-line',
  },
  {
    title: '恋爱甜宠漫画特辑',
    desc: '从校园初恋到职场浪漫，治愈系恋爱漫画全收录，甜蜜暴击预警',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20with%20couple%20under%20blooming%20cherry%20trees%2C%20soft%20pink%20and%20peach%20tones%2C%20gentle%20atmosphere%2C%20clean%20anime%20illustration%20style%2C%20dreamy%20composition%2C%20minimal%20cream%20background&width=1200&height=600&seq=carousel-manga-05&orientation=landscape',
    tag: '恋爱',
    icon: 'ri-heart-line',
  },
  {
    title: '悬疑烧脑漫画精选',
    desc: '高智商对决与层层反转，让你停不下来的悬疑推理漫画大合集',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20scene%20with%20dramatic%20shadows%20and%20silhouettes%2C%20noir%20atmosphere%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20clean%20illustration%20style%2C%20suspenseful%20composition%2C%20minimal%20beige%20background&width=1200&height=600&seq=carousel-manga-06&orientation=landscape',
    tag: '悬疑',
    icon: 'ri-search-eye-line',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精心策划的漫画专题合集，发现你的下一部最爱
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden cursor-pointer transition-transform hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                  <i className={`${item.icon} text-[10px]`}></i>{item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}